import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { FavoriteService } from '../../service/favorite.service';
import { FilterService } from '../../service/filter.service';
import { FilterState } from '../../classes/filter.state';
import { Logger } from '../../logging/default-log.service';
import { Product } from '../../classes/product';
import { NgClass } from '@angular/common';

@Component({
    selector: 'productitem-favorite',
    styleUrls: ['./productitem.favorite.component.scss'],
    templateUrl: 'productitem.favorite.component.html',
    standalone: true,
    imports: [NgClass]
})
export class ProductItemFavoriteComponent {
  private filterService = inject(FilterService);
  private favoriteService = inject(FavoriteService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private logger = inject(Logger);

  @Input()
  public product: Product;

  awaitingResponse: boolean = false;

  /**
   * Set or unset favorite status based on current status.
   * Disable button while awaiting response of backend call.
   */
  toggleFavorite() {
    const filterState: FilterState = this.filterService.getFilterState();

    this.awaitingResponse = true;

    this.favoriteService.toggleFavorite(this.product, filterState).subscribe({
      next: (favorite) => {
        this.product.favorite = favorite;
      },
      error: (error) => {
        this.logger.error(
          'Failed to toggle favorite for ' + this.product.totalDescription1,
          error
        );
      },
      complete: () => {
        this.awaitingResponse = false;
        this.changeDetectorRef.detectChanges();
      }
    });
  }
}
